import { render, staticRenderFns } from "./FilterDrawer.vue?vue&type=template&id=2da6f93a&"
import script from "./FilterDrawer.vue?vue&type=script&lang=js&"
export * from "./FilterDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QForm} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QForm})
